
import { Component, Vue } from 'vue-property-decorator';
import { RigaReintegro, Reintegro } from '@/models';
import { store, StoreActions } from '@/store';

@Component
export default class RigheReintegroList extends Vue {       
  get reintegro(): Reintegro | undefined { return store.state.reintegroCorrente; }
  
  get righeReintegro(): RigaReintegro[]
  {
      if(this.reintegro) {
          return this.reintegro.righeReintegro;
      }
      return [];
  }

  get user() {return store.state.currentUsr;}

  private nomeFornitore(idFornitore: string): string {
    let nomeFornitore: string = '';

    let fornitore = store.state.fornitori.find(f => f.id == idFornitore);
    if (fornitore) nomeFornitore = fornitore.nome;

    return nomeFornitore;
  }

  get userIsAdmin() {
    return (
      this.user.roles.find((x: string) => x.toLowerCase() == 'admin') !=
      undefined
    );
  }

  private quantitaPerTaglia(riga: RigaReintegro): any {
    let quantita: any = [];

    let tipoTaglia: any = riga.tipoTagliaDecodificato;
    for (let index = 1; index <= 32; index++) {
      const nomeProp = `taglia${index.toString().padStart(2, '0')}`;
      const valProp: string = tipoTaglia[nomeProp];

      let end = valProp == undefined || valProp == '';
      if (!end) {
          quantita.push(
              {
                desc: valProp,
                indice: index,
                qta: riga.quantitaDaIntegrare[index - 1]
              }
          )
        
      }
    }

    return quantita;
  }
}
